import React, { useState } from "react";
import { faqData } from "./faqData"; // Importing the FAQ raw data
import { FaSearch, FaChevronDown } from "react-icons/fa"; // Importing icons

const FaqPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswer, setNewAnswer] = useState("");
  const [faqList, setFaqList] = useState(faqData); // State for the FAQ list
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Dropdown state for tags
  const [selectedTag, setSelectedTag] = useState(""); // Selected tag

  const faqsPerPage = 8;

  // Calculate total pages based on FAQs length
  const totalPages = Math.ceil(faqList.length / faqsPerPage);

  // Get FAQs for the current page
  const indexOfLastFaq = currentPage * faqsPerPage;
  const indexOfFirstFaq = indexOfLastFaq - faqsPerPage;
  const currentFaqs = faqList.slice(indexOfFirstFaq, indexOfLastFaq);

  // Handle page change
  const handlePageChange = (page) => setCurrentPage(page);

  // Toggle dropdown visibility for individual FAQs
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleDropdown = (index) => {
    setOpenIndexes(openIndexes.includes(index)
      ? openIndexes.filter((i) => i !== index)
      : [...openIndexes, index]);
  };

  // Handle search input and suggestions
  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchTerm(searchTerm);

    if (searchTerm) {
      const filteredFaqs = faqData.filter((faq) =>
        faq.question.toLowerCase().includes(searchTerm)
      );
      setFaqList(filteredFaqs);
      setCurrentPage(1);
    } else {
      setFaqList(faqData);
    }
  };

  // Handle adding a new FAQ
  const handleAddFaq = () => {
    if (newQuestion && newAnswer) {
      const newFaq = { question: newQuestion, answer: newAnswer };
      setFaqList([newFaq, ...faqList]); // Add the new FAQ to the top of the list
      setNewQuestion("");
      setNewAnswer("");
    }
  };

  // Handle tag selection
  const handleTagSelect = (tag) => {
    setSelectedTag(tag);
    setIsDropdownOpen(false);
  };

  return (
    <div className="faq-page-container" style={{ padding: "20px" }}>
      {/* Search Bar */}
      <div style={{ marginBottom: "20px", position: "relative", width: "100%" }}>
        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          {/* Search Icon */}
          <FaSearch
            style={{
              position: "absolute",
              left: "10px",
              fontSize: "1.2rem",
              color: "#999",
            }}
          />
          <input
            type="text"
            placeholder="Search FAQs..."
            value={searchTerm}
            onChange={handleSearch}
            style={{
              width: "100%",
              padding: "10px 40px 10px 35px", // Padding adjusted for the icon
              fontSize: "1rem",
              borderRadius: "10px",
              border: "1px solid #ccc",
            }}
          />

          {/* Dropdown Icon */}
          <FaChevronDown
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            style={{
              position: "absolute",
              right: "10px",
              fontSize: "1.2rem",
              color: "#999",
              cursor: "pointer",
            }}
          />
        </div>

        {/* Dropdown Menu for Tags */}
        {isDropdownOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              backgroundColor: "#fff",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              zIndex: 1,
              padding: "10px",
            }}
          >
            {["FNFT", "Launchpad", "New", "Old"].map((tag) => (
              <div
                key={tag}
                onClick={() => handleTagSelect(tag)}
                style={{
                  padding: "10px",
                  cursor: "pointer",
                  borderBottom: "1px solid #ddd",
                  color: selectedTag === tag ? "#d63333" : "#000",
                  fontWeight: selectedTag === tag ? "bold" : "normal",
                }}
              >
                {tag}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* FAQ List */}
      {currentFaqs.map((faq, index) => (
        <div
          key={index}
          className="faq-item"
          style={{
            background: "#fff",
            borderRadius: "10px",
            marginBottom: "10px",
            padding: "15px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            transition: "all 0.3s ease",
          }}
        >
          <div
            onClick={() => toggleDropdown(index)}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "1.2rem" }}>{faq.question}</span>
            <span>{openIndexes.includes(index) ? "-" : "+"}</span>
          </div>

          {openIndexes.includes(index) && (
            <div
              style={{
                padding: "10px",
                marginTop: "10px",
                backgroundColor: "#f9f9f9",
                borderRadius: "10px",
              }}
            >
              {faq.answer}
            </div>
          )}
        </div>
      ))}

      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => handlePageChange(index + 1)}
            style={{
              margin: "0 5px",
              padding: "5px 10px",
              backgroundColor: currentPage === index + 1 ? "#d63333" : "#e0e0e0",
              color: currentPage === index + 1 ? "#fff" : "#000",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {index + 1}
          </button>
        ))}
      </div>

      {/* Add New FAQ Section */}
      <div
        style={{
          marginTop: "30px",
          padding: "20px",
          background: "#f8f8f8",
          borderRadius: "10px",
        }}
      >
        <h2>Add a new FAQ</h2>
        <div style={{ marginBottom: "10px" }}>
          <input
            type="text"
            placeholder="Enter question..."
            value={newQuestion}
            onChange={(e) => setNewQuestion(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              fontSize: "1rem",
              borderRadius: "10px",
              border: "1px solid #ccc",
              marginBottom: "10px",
            }}
          />
          <textarea
            placeholder="Enter answer..."
            value={newAnswer}
            onChange={(e) => setNewAnswer(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              fontSize: "1rem",
              borderRadius: "10px",
              border: "1px solid #ccc",
              height: "100px",
            }}
          />
        </div>
        <button
          onClick={handleAddFaq}
          style={{
            backgroundColor: "#007bff",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Add FAQ
        </button>
      </div>
    </div>
  );
};

export default FaqPage;
